import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function ServiceDetails() {
  const { id } = useParams(); // ye ServiceId hai
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getServiceDetails = async () => {
    try {
      const res = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServiceDetailList?ServiceId=${id}`
      );

      console.log("API RESPONSE:", res.data);

      setData(res.data.data || []);
    } catch (error) {
      console.error("API ERROR:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getServiceDetails();
    }
  }, [id]);

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Service Details</h2>

      {loading ? (
        <p>Loading...</p>
      ) : data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="card p-3 mb-3 shadow-sm">
            <h5>{item.serviceName}</h5>
            <p>{item.description}</p>
          </div>
        ))
      ) : (
        <p>No Data Found</p>
      )}
    </div>
  );
}

export default ServiceDetails;